import { t as lingoT }  from '@tencent/lingo-sdk/dist/react';
import { initI18n } from './index';
import { I18NTranslationOptions } from '@tencent/tea-app/lib/core/i18n';

export function t(sentence: string, option?: I18NTranslationOptions | undefined) { 
  initI18n();
  return lingoT(sentence, option);
}